import { useEffect, useState } from "react";
import styled from "styled-components";
import Modal from "../Base/Modal";
import LinkedAccounts from "../../components/LinkedAccounts/LinkedAccounts";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 800px;

  .header {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .title {
      font-weight: 700;
      font-size: 32px;
      color: #004576;
      cursor: pointer;
      border-bottom: 4px solid lightgray;
    }

    .active {
      border-bottom: 4px solid #48c8f4 !important;
    }

    .crossButton {
      font-size: 30px;
      cursor: pointer;
    }
  }

  .body {
    .textField {
      background: transparent;
      border-bottom: 1px solid #6ac7dd;
      padding: 5px 5px;
      width: 100%;
      margin-top: 30px;
      font-size: 16px;
    }

    .disabledTextField {
      background-color: lightgray;
      color: white;
    }
  }

  .footer {
    width: 100%;
    text-align: right;

    .buttton {
      margin-top: 20px;
      background: #004576;
      border-radius: 4px;
      padding: 15px 20px;
      color: white;
      font-weight: 700;
      cursor: pointer;
    }

    .errorMessage {
      color: red;
      font-size: 12px;
      margin-top: 10px;
    }
  }
`;

const AdvisorPortalEditUserInfo = ({
  isAdvisorPortalEditUSerInfoModalShow,
  isAdvisorPortalEditUSerInfoModalShowOnClose,
  editDetails,
  handleEditSubmit,
}) => {
  const [firstName, setFirstName] = useState(editDetails.firstName);
  const [lastName, setLastName] = useState(editDetails.lastName);
  const [email, setEmail] = useState(editDetails.email);
  const [phoneNo, setPhoneNo] = useState(editDetails.phoneNumber);
  const [ria, setRia] = useState();
  const [role, setRole] = useState(editDetails.role);
  const [isEditActivated, setIsEditActivated] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    setFirstName(editDetails.firstName);
    setLastName(editDetails.lastName);
    setEmail(editDetails.email);
    setPhoneNo(editDetails.phoneNumber);
    setRole(editDetails.role);
  }, [editDetails]);

  const handleTextBoxChange = (e) => {
    if (e.target.name === "firstName") {
      setFirstName(e.target.value);
    }
    if (e.target.name === "lastName") {
      setLastName(e.target.value);
    }
    if (e.target.name === "email") {
      setEmail(e.target.value);
    }
    if (e.target.name === "phoneNo") {
      setPhoneNo(e.target.value);
    }
    if (e.target.name === "ria") {
      setRia(e.target.value);
    }
    if (e.target.name === "role") {
      setRole(e.target.value);
    }
  };

  const handleSubmit = () => {
    if (firstName && lastName && email) {
      handleEditSubmit(firstName, lastName, email, phoneNo, role);
    } else {
      setErrorMessage("All the fields are mandatory");
    }
  };
  return (
    <Modal
      show={isAdvisorPortalEditUSerInfoModalShow}
      onClose={isAdvisorPortalEditUSerInfoModalShowOnClose}
    >
      <Wrapper>
        <div className="header">
          <div style={{ display: "flex", gap: "10px" }}>
            <div
              className={`title ${isEditActivated && "active"}`}
              onClick={() => setIsEditActivated(!isEditActivated)}
            >
              Edit User
            </div>
            <div
              className={`title ${!isEditActivated && "active"}`}
              onClick={() => setIsEditActivated(!isEditActivated)}
            >
              Managed Linked Accounts
            </div>
          </div>
          <div
            className="crossButton"
            onClick={isAdvisorPortalEditUSerInfoModalShowOnClose}
          >
            X
          </div>
        </div>
        {isEditActivated ? (
          <div className="body">
            <input
              name="firstName"
              placeholder="First Name"
              className="textField"
              value={firstName}
              onChange={handleTextBoxChange}
            />
            <input
              name="lastName"
              placeholder="Last Name"
              className="textField"
              value={lastName}
              onChange={handleTextBoxChange}
            />
            <input
              name="email"
              placeholder="Email"
              className="textField"
              value={email}
              onChange={handleTextBoxChange}
            />
            <input
              name="phoneNumber"
              placeholder="Phone Number"
              className="textField"
              value={phoneNo}
              onChange={handleTextBoxChange}
            />
            <input
              name="role"
              placeholder="Role"
              className="textField disabledTextField"
              disabled={true}
              value={role}
              onChange={handleTextBoxChange}
            />
          </div>
        ) : (
          <>
            <LinkedAccounts
              email={""}
              onMasterAccountStateUpdate={() => {}}
              preLoadedMasterAccounts={editDetails?.masterAccounts || []}
              advisorId={editDetails?.advisorId || ""}
              masterAccountIdProps={editDetails?.id || ""}
            />
          </>
        )}
        {isEditActivated && (
          <div className="footer">
            <button className="buttton" onClick={handleSubmit}>
              Submit
            </button>
            <div className="errorMessage">{errorMessage}</div>
          </div>
        )}
      </Wrapper>
    </Modal>
  );
};

export default AdvisorPortalEditUserInfo;
